import {DrugItemDetailsType} from '../../../interfaces/api/tabs';
import {services} from '../../../api';

/**
 * this function to get Drug Details
 *
 * @return {DrugItemDetailsType[] | null} news details
 */
export const getDrugDetails = async (
  id: string,
  isDiseases?: boolean,
): Promise<DrugItemDetailsType[] | null> => {
  try {
    const res = await services.news.getDrugDetails(id, isDiseases);
    return res?.content?.sections || [];
  } catch (error: any) {
    return null;
  }
};
